import {
  Resources,
  content,
  AddItemToContentList,
  RemoveItemFromContentList,
  AddContentFromPutRequest,
  archivedContent
} from "./contentRedux";
import {
  ContentUploadModal,
  progress,
  removeProgress,
  hideModal
} from "./uploadModalReducer";
import { ContentTagResources, ContentTag } from "./TagReducer";
import { SponserTagResources, SponserTag } from "./SponserReducer";

const contentReducer = {
  ContentUploadModal,
  content,
  ContentTag,
  archivedContent,
  SponserTag
};

export {
  contentReducer,
  Resources,
  progress,
  hideModal,
  removeProgress,
  AddItemToContentList,
  RemoveItemFromContentList,
  AddContentFromPutRequest,
  ContentTagResources,
  SponserTagResources
};
